import http from '@/libs/AxiosPlugin'

const product = {
  list () {
    return http.get('/product/list')
    // return new Promise((resolve, reject) => {
      // let data = [
      //   {id: 1, productNo: 'xt-001', name: '呆呆', latDensity: 10, density: 22, kaidu: 12, width: 32, specifications: '12345678901', valid: 1, image: 'https://cdn.lljgame.com/FlypplRUJ3TwzjaQxPtBtS8FvZtf'}
      // ]
      // resolve(data)
    // })
  },

  get (id) {
    return http.post('/product/get', {id})
  },

  save (product) {
    return http.post('/product/save', product)
  },

  delete (id) {
    return http.post('/product/delete', {id})
  }
}

export default product



// WEBPACK FOOTER //
// ./src/api/product.js